/**
 * Used as a default placeholder if a name object doesn't have a first name and a last name
 */
export const undefinedNamePlaceholder = '-';
